import React from 'react';
import { Label } from '../developers/page-components/Label';

interface Props {
  uploadedFile: string;
  label: string;
}

const LogoPreview = (props: Props): React.ReactElement => {
  const { uploadedFile, label } = props;
  return (
    <div className="col-6 col-sm-4 col-md-3 fv-row">
      <Label fieldLabel={label} additionalClass="text-muted fs-6 mb-1"/>
        <div className="fv-plugins-message-container text-danger">
          <div className="fv-help-block">
            <img src={uploadedFile} width="150"/>
          </div>
        </div>
    </div>
  );
};

export default LogoPreview;
